var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaitlistUserNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27 2H7a2 2 0 0 0-2 2v2H4a1 1 0 0 0 0 2h1v7H4a1 1 0 0 0 0 2h1v7H4a1 1 0 0 0 0 2h1v2a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM7 28v-2h1a1 1 0 0 0 0-2H7v-7h1a1 1 0 0 0 0-2H7V8h1a1 1 0 0 0 0-2H7V4h20v24zm10-12.5a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm3 7h-6a3 3 0 0 0-3 3v3a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a3 3 0 0 0-3-3zm1 6h-8v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z",
    "data-name": "07 contact",
    fill: "#666b84",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitlistUserNew);
export default __webpack_public_path__ + "static/media/waitlist-user-new.2b5b7cd59d6841a90a63201a534e29ce.svg";
export { ForwardRef as ReactComponent };